import { render } from "./ProgramInnerPage.vue?vue&type=template&id=7d647fe0&scoped=true"
import script from "./ProgramInnerPage.vue?vue&type=script&lang=js"
export * from "./ProgramInnerPage.vue?vue&type=script&lang=js"

import "./ProgramInnerPage.vue?vue&type=style&index=0&id=7d647fe0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d647fe0"]])

export default __exports__